import { Component, OnInit,  HostListener} from '@angular/core';

@Component({
  selector: 'app-criteria-two',
  templateUrl: './criteria-two.component.html',
  styleUrls: ['./criteria-two.component.scss']
})
export class CriteriaTwoComponent implements OnInit {
  @HostListener("click") onClick(){
    this.checkRoute();
  }
  fullWidth=false;
  showSideMenu = true;
  // showHeading = false;
  constructor() { }

  ngOnInit(): void {
    this.checkRoute();
  }

  splitUrl(){
    let url=location.pathname.split('/');
    // console.log(url);
    if(url.length === 4 || (url.length===5 &&(url[4]==='2-2-1' || url[4]==='2-4-1' || url[4]==='2-4-2' || url[4]==='2-6-3'))){
      this.showSideMenu=true;
      this.fullWidth=false;
      // this.showHeading = true;
    }
    else{
      this.showSideMenu=false;
      this.fullWidth=true;
    }
  }
  checkRoute(){
    setTimeout(()=>{
      this.splitUrl();
    })
  }
}

